import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    departmentId: null,
}

export const sliceDept = createSlice({
    name: 'deptStats',
    initialState,
    reducers: {
        UpdateDepartment:{
            reducer(state, action){
                state.departmentId = action.payload
            },
            prepare(departmentData) {
                return{
                    payload: departmentData
                }
            }
        },       
    }
});

export const { 
    UpdateDepartment, 
} = sliceDept.actions;

export default sliceDept.reducer;